if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then(reg => {
            reg.onupdatefound = () => {
                const installingWorker = reg.installing;

                installingWorker.onstatechange = () => {
                    switch (installingWorker.state) {
                        case 'installed':
                            if (navigator.serviceWorker.controller) {
                                document
                                    .querySelector('#pwa-update-reload-app')
                                    .addEventListener('click', e => {
                                        e.preventDefault();
                                        window.location.reload();
                                    });

                                const $prompt = document.querySelector(
                                    '#pwa-update-available',
                                );

                                $prompt.classList.remove('hidden');

                                gsap.from($prompt, {
                                    opacity: 0,
                                    y: '-=10',
                                    duration: 0.7,
                                });
                            }
                    }
                };
            };
        });
    });
}

window.addEventListener('appinstalled', evt => {
    if (typeof ga !== 'undefined') {
        ga('send', 'event', 'installed_app', 'installed');
    }
});

// window.addEventListener('DOMContentLoaded', () => {
//     let displayMode = 'browser tab';
//     if (navigator.standalone) {
//         displayMode = 'standalone-ios';
//     }
//     if (window.matchMedia('(display-mode: standalone)').matches) {
//         displayMode = 'standalone';
//     }
//     // Log launch display mode to analytics
//     console.log('DISPLAY_MODE_LAUNCH:', displayMode);
// });

// window.addEventListener('DOMContentLoaded', () => {
//     window.matchMedia('(display-mode: standalone)').addListener(evt => {
//         let displayMode = 'browser tab';
//         if (evt.matches) {
//             displayMode = 'standalone';
//         }
//         // Log display mode change to analytics
//         console.log('DISPLAY_MODE_CHANGED', displayMode);
//     });
// });
